import { TemplateWrapped } from "../../Layout";
import CustomPanel from "../../CustomPanel";
import SummaryReportForm from "../../Reports/SummaryReportForm";
import { useContext, useEffect, useState } from "react";
import { getClients } from "../ClientPermissions/clientPermissions.service";
import { generateReport } from "./clientCostReport.service";
import { toast } from "react-toastify";
import { groupPractices } from "../Connections/connections.middleware";
import { AppContext } from "../../../App";
import { initialValues as item } from "../ClientPractice/useClientPractice";

const formatClients = (clientResponse) => {
  const { records } = clientResponse;

  return records
    .map((client) => ({
      id: client._id,
      name: client.name,
    }))
    .map((client) => ({
      value: client.id,
      label: client.name,
    }));
};

const ClientCostReport = () => {
  const appData = useContext(AppContext);
  const practices = appData.get("practices") || [];
  const [clients, setClients] = useState([]);

  useEffect(() => {
    async function fetchClients() {
      let obj = groupPractices(practices);

      const allPractices = Object.values(obj);
      setClients(
        allPractices.map((item) => {
          return {
            value: item.clientId,
            label: item.clientName,
          };
        }),
      );
    }

    fetchClients();
  }, []);

  const handleSubmit = async (values) => {
    const currentClient = clients.find(
      (client) => client.value === values.clientId,
    );
    const [state, files] = await generateReport(values);

    if (!state || !files) {
      toast.error("Error downloading the file");
      return;
    }
    const reportName = `${currentClient.label}_${values.startDate}_${values.endDate}_report.xlsx`;

    const url = window.URL.createObjectURL(
      new Blob([files.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      }),
    );
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", reportName);
    document.body.appendChild(link);
    link.click();
    toast.success("The file has been downloaded successfully");
  };

  return (
    <TemplateWrapped>
      <CustomPanel>
        <SummaryReportForm
          onSubmit={handleSubmit}
          labelSelection="Client"
          initialValues={{
            clientId: "",
            startDate: "",
            endDate: "",
          }}
          options={clients}
          selectName="clientId"
        />
      </CustomPanel>
    </TemplateWrapped>
  );
};

export default ClientCostReport;
